module.exports = __webpack_public_path__ + "static/media/edit.5679e943.svg";